import { RMHelpURL } from 'utils/Global';

export const EXTERNAL_LINKS = {
  AUTOSCORE_WEBHELP: `${RMHelpURL}/Content/Viewing_and_Scoring_Images/Scoring_Images/Scoring_Images_Using_Autoscoring_Models.html#sherlock`,
  BATCHLOAD_WIZARD_WEBHELP: `${RMHelpURL}/Content/Experiment_Design/Experiment_Design_Tutorials/Designing_Experiments/Creating_Multiple_Experiments_Using_Batchload_Experiment_Wizard.html`,
} as const;
